import { useLayoutEffect } from 'react'
import type { LocationEditorState } from '../types'

export function useScrollToSelectedItem(state: LocationEditorState, popper: HTMLDivElement | null) {
  const { open, dropdownSelectedIndex, dropdownOptions } = state

  useLayoutEffect(() => {
    if (popper === null) return
    if (!open) return
    if (dropdownSelectedIndex === -1) return

    const selectedElement = popper.querySelector<HTMLDivElement>(
      `[data-asset-id="${dropdownOptions[dropdownSelectedIndex].id}"]`,
    )
    if (!selectedElement) return

    selectedElement.scrollIntoView({ block: 'start' })
  }, [popper, dropdownSelectedIndex, open, dropdownOptions])
}
